const API_BASE = (
  process.env.REACT_APP_GOOURHUB_BUSINESS_API ||
  "https://business-api.goourhub.com"
).replace(/\/+$/, "");

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }

    url.searchParams.set(key, String(value));
  });

  return url.toString();
}

async function readJson(response) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message || `Business directory request failed (${response.status}).`
    );
  }

  return data;
}

export async function getBusinesses({
  community = "",
  category = "",
  language = "",
  query = "",
  page = 1,
  limit = 24,
  sort = "name",
  signal,
} = {}) {
  const response = await fetch(
    buildUrl("/api/businesses", {
      community,
      category,
      language,
      q: query,
      page,
      limit,
      sort,
    }),
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      signal,
    }
  );

  const data = await readJson(response);

  return {
    businesses: Array.isArray(data.businesses) ? data.businesses : [],
    pagination: data.pagination || {
      page,
      limit,
      total: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
    },
  };
}

export async function getAllBusinessesByCommunity(
  community,
  { signal } = {}
) {
  const limit = 200;
  let page = 1;
  let hasNext = true;
  const businesses = [];

  while (hasNext) {
    const result = await getBusinesses({
      community,
      page,
      limit,
      sort: "name",
      signal,
    });

    businesses.push(...result.businesses);
    hasNext = Boolean(result.pagination?.hasNext);
    page += 1;
  }

  return businesses;
}
